type FormFooterProps = {
  children: NonNullable<React.ReactNode>
}

export function FormFooter({ children }: FormFooterProps) {
  return <footer className="d-f jc-c">{children}</footer>
}
